import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TOrderFormParamsLayoutService = {
  payload: {
    paramsType?: string
  }
}

export const orderFormParamsLayoutService = async ({
  payload,
}: TOrderFormParamsLayoutService): Promise<ResponseAPI> => {
  const response = await api.get(`parametroslayout/${payload.paramsType}`)

  return response.data
}
